import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { RuleFiredCommon } from "./RuleFiredCommon";

export const RuleEngineAdvancementRuleFiredFragment = graphql(`
  fragment RuleEngineAdvancementRuleFiredFields on RuleEngineAdvancementRuleFiredPayload {
    __typename
    ruleId
    ruleName
    ruleSetId
    ruleSetVersion
    triggerType
    triggerEventTypename
    triggerEventJson
    conditionSource
    conditionResult {
      matched
      value
    }
    actionSource
    engineTiming {
      conditionEvalMs
      actionExecMs
      totalMs
    }
    printOutput
    printOutputTruncated
    error {
      code
      message
      hint
      stackHint
    }
    manualOverride {
      overriddenBy
      reason
    }
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineAdvancementRuleFiredFragment>;
}

export function RuleEngineAdvancementRuleFiredPayload({ data }: Props) {
  const p = readFragment(RuleEngineAdvancementRuleFiredFragment, data);
  return (
    <RuleFiredCommon
      ruleName={p.ruleName}
      ruleId={p.ruleId}
      ruleSetVersion={p.ruleSetVersion}
      triggerType={p.triggerType}
      triggerEventTypename={p.triggerEventTypename}
      conditionSource={p.conditionSource}
      conditionResult={p.conditionResult}
      actionSource={p.actionSource}
      engineTiming={p.engineTiming}
      printOutput={p.printOutput}
      printOutputTruncated={p.printOutputTruncated}
      error={p.error}
      manualOverride={p.manualOverride}
      kindColor="blue"
      kindLabel="ADVANCEMENT"
    />
  );
}
